import { render, staticRenderFns } from "./#list.vue?vue&type=template&id=22778f14&"
import script from "./#list.vue?vue&type=script&lang=js&"
export * from "./#list.vue?vue&type=script&lang=js&"
import style0 from "./#list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports